
export default (name, model = {}) => {
  let newModel = {}
  for (const [key, value] of Object.entries(model)) {
    const keyName = key.charAt(0).toUpperCase() + key.slice(1)
    newModel[`${name}${keyName}`] = value
  }
  return newModel
}
